import { FileCategory } from '@/models/binder-file';
import { effect, inject, Injectable, signal } from '@angular/core';
import { DocGeneratorService } from '../api/doc-generator.service';
import { FilesService } from '../api/files.service';

@Injectable({
  providedIn: 'root'
})
export class SelectedDocService {
  selectedDocSignal = signal<FileCategory | null>(null);
  private filesService = inject(FilesService);

  constructor(
    private docGenerator:DocGeneratorService
  ) {
    effect(() => {
      const cats = this.filesService.categories();
      if(cats.length > 0) {
        this.setSelection(this.categories[0])
      }
   }
  )
}

   get categories() {
    return this.filesService.categories().filter(category => category.archived !== true)
   }

  setSelection(category:FileCategory){
    this.selectedDocSignal.set(category);
  }

  setSelectionById(id:number){
    const category = this.categories.find(category => category.fileCategoryId === id);
    if(category){
      this.selectedDocSignal.set(category);
    }

  }
}
